module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAl0lEQVR4Ae3SoRGDQBhE4ReBwaMRSQF0QBUUcV1QAJXQBRXQAhp/BrOJQGQyCf9dAMHMfc+vWg6R3HlwgIr5VcVONR4hPDU7NCxobaHhTw595Ih2o0Nf6oiS0aMf9WQEyhnQRgM5NgpGZDRSYCiZkB0TpXU+BTZTWecLzVNb5zPaOqlDMdknbVFgLaurDr1LQ2no/KHkgp494I7WqW28sQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/map/images/company.png
// module id = 1170
// module chunks = 0